import { render } from "./RuiButton.vue?vue&type=template&id=f21cbf5a&scoped=true"
import script from "./RuiButton.vue?vue&type=script&lang=ts"
export * from "./RuiButton.vue?vue&type=script&lang=ts"

import "./RuiButton.vue?vue&type=style&index=0&id=f21cbf5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f21cbf5a"

export default script